export const FirstPlaceAwardIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.55787 21.442L8.31634 20.732L8.55787 21.442C9.14092 21.2437 9.78495 21.453 10.1401 21.9561C11.2911 23.587 13.7098 23.587 14.8608 21.9561C15.216 21.453 15.86 21.2437 16.4431 21.442L16.6846 20.732L16.4431 21.442C18.3329 22.0849 20.2896 20.6632 20.2622 18.6672C20.2538 18.0514 20.6518 17.5036 21.2401 17.3213C23.1468 16.7306 23.8942 14.4303 22.6989 12.8316C22.3301 12.3384 22.3301 11.6612 22.6989 11.168C23.8942 9.56931 23.1468 7.26899 21.2401 6.67825C20.6518 6.49599 20.2538 5.94814 20.2622 5.33234C20.2896 3.33639 18.3329 1.91472 16.4431 2.55754C15.86 2.75587 15.216 2.54661 14.8608 2.04345C13.7098 0.412599 11.2911 0.412599 10.1401 2.04345L10.7528 2.47593L10.1401 2.04345C9.78495 2.54661 9.14092 2.75587 8.55787 2.55754C6.66806 1.91472 4.7113 3.33639 4.73868 5.33234C4.74713 5.94815 4.3491 6.49599 3.76082 6.67825C1.8541 7.26899 1.10668 9.5693 2.30203 11.168L2.90268 10.7188L2.30203 11.168C2.67082 11.6612 2.67082 12.3384 2.30203 12.8316L2.90268 13.2807L2.30203 12.8316C1.10668 14.4303 1.8541 16.7306 3.76082 17.3213C4.3491 17.5036 4.74713 18.0514 4.73868 18.6672C4.7113 20.6632 6.66806 22.0849 8.55787 21.442Z"
        fill="url(#paint0_linear_584_34798)"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M10.8669 8.25V6.794H13.7789V17H12.1689V8.25H10.8669Z" fill="#222222" />
      <defs>
        <linearGradient
          id="paint0_linear_584_34798"
          x1="0.499999"
          y1="23.9998"
          x2="24.5"
          y2="-0.000213204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8B905" />
          <stop offset="1" stopColor="#FAD25F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
